import NavbarComponent from "../../components/NavbarComponent";
import React from "react";
import {Box, Tab, Tabs} from "@mui/material";
import {Link} from "react-router-dom";

function ManagementNavbar({initValue}) {

    const [value, setValue] = React.useState(initValue);

    function handleChange(event, newValue) {
        setValue(newValue);
    }

    return (
        <div>
            <NavbarComponent initValue={"/management/courses"}/>
            <Box sx={{width: '100%', margin: '10px', borderBottom: '1px solid lightgrey'}}>
                <Tabs value={value} onChange={handleChange} variant={"fullWidth"} defaultValue={"/management/courses"}>
                    <Tab label={"Kurse"} value={"/management/courses"} component={Link} to={"/management/courses"}/>
                    <Tab label={"Mitarbeiter"} value={"/management/employees"} component={Link} to={"/management/employees"}/>
                    <Tab label={"Führungskräfte"} value={"/management/executives"} component={Link} to={"/management/executives"}/>
                </Tabs>
            </Box>
        </div>
    )

}

export default ManagementNavbar;